import React from 'react';

const ScreenWidthContext = React.createContext({
    screenWidth: window.innerWidth as number,
    setScreenWidth: (screenWidth: number) => {}
  })

export default ScreenWidthContext